const CustomerCategory = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "customer_category": "Customer Category",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

}

export default CustomerCategory;